import { Mark, mergeAttributes } from '@tiptap/core';

export const VariableSpan = Mark.create({
  name: 'variableSpan',
  group: 'inline',
  inline: true,
  content: 'inline*', // Allow nested span inside
  parseHTML() {
    return [
      {
        tag: 'span[data-placeholderid]',
        getAttrs: element => ({
          id: element.getAttribute('id'),
          'data-placeholderid': element.getAttribute('data-placeholderid'),
          style: element.getAttribute('style') // Preserve styles
        })
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ['span', mergeAttributes(HTMLAttributes), 0];
  },
  addAttributes() {
    return {
      id: {
        default: null
      },
      'data-placeholderid': {
        default: null
      },
      style: {
        default: null
      }
    };
  }
});
